import React from 'react';
import { useTranslation } from 'react-i18next';
import './SetupWizard.css';

const SetupWizardHeader = ({ 
  currentStep, 
  totalSteps, 
  stepTitle, 
  progressPercentage,
  // Navigation props
  completedSteps,
  validationErrors,
  canProceed,
  onNext,
  onBack,
  onSkip,
  onFinish,
  isLastStep
}) => {
  const { t } = useTranslation('setup');
  const isStepCompleted = completedSteps?.includes(currentStep) || false;
  const hasErrors = validationErrors && validationErrors.length > 0;
  const canContinue = isStepCompleted && !hasErrors;

  return (
    <div className="setup-wizard-header">
      <div className="setup-wizard-header-content">
        <div className="setup-wizard-title-section">
          <div className="setup-wizard-title">
            <span className="wizard-label">{t('header.wizardLabel')}</span>
            <span className="step-title-inline">{stepTitle}</span>
          </div>
        </div>
        
        <div className="setup-wizard-progress-section">
          <div className="progress-info-compact">
            <span className="step-indicator">{t('header.stepIndicator', { current: currentStep, total: totalSteps })}</span>
            <span className="progress-percentage">{progressPercentage}%</span>
          </div>
          <div className="progress-bar-container-compact">
            <div 
              className="progress-bar-fill" 
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
          <div className="setup-wizard-header-navigation">
            {currentStep > 1 && (
              <button
                className="btn-header btn-header-secondary"
                onClick={onBack}
                type="button"
              >
                {t('header.back')}
              </button>
            )}
            
            {!isLastStep && (
              <>
                {canContinue && (
                  <button
                    className="btn-header btn-header-primary"
                    onClick={onNext}
                    type="button"
                  >
                    {t('header.continue')}
                  </button>
                )}
                
                {!canContinue && currentStep !== 1 && (
                  <button
                    className="btn-header btn-header-secondary"
                    onClick={onSkip}
                    type="button"
                    title={t('header.skipTooltip')}
                  >
                    {t('header.skip')}
                  </button>
                )}
              </>
            )}
            
            {isLastStep && (
              <button
                className="btn-header btn-header-primary"
                onClick={onFinish}
                type="button"
              >
                {t('header.finish')}
              </button>
            )}
          </div>
        </div>
      </div>
      
      {/* Validation messages - compact */}
      {hasErrors && (
        <div className="setup-wizard-header-validation">
          <span className="validation-message">{t('header.validationError')}</span>
        </div>
      )}
      
      {!isStepCompleted && !hasErrors && currentStep === 1 && (
        <div className="setup-wizard-header-guidance">
          <span>{t('header.step1Guidance')}</span>
        </div>
      )}
    </div>
  );
};

export default SetupWizardHeader;
